import React, { useRef } from 'react';
import styled from 'styled-components';

import Column from 'components/common/Column';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { ScheduleParam } from 'containers/ProductRegist/hooks/types';
import { ONLY_NUMBER_REGEX } from 'utils/regExp';

const RecruitContainer = styled.div<{ $disable: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  position: relative;

  padding: 12px;
  width: 100%;

  border-radius: 12px;
  border: 1px solid #eaebec;
  /* background: #fff; */

  background: ${props => (props.$disable ? '#f7f7f8' : '#fff')};

  cursor: ${props => (props.$disable ? 'auto' : 'pointer')};

  &:focus-within {
    border: 1.5px solid #1b1c1e;
  }

  > input {
    background: inherit;
  }
`;

const RecruitInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: inherit;
  max-width: 50px;

  text-align: right;
  border-radius: 8px;
  border: none;
  background: #fff;

  color: #414b56;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.064px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::placeholder {
    justify-content: flex-end;
  }
`;

interface Props {
  scheduleItem: ScheduleParam;
  isDisable: boolean;
  handleSetScheduleItem: (changes: Record<string, any>) => void;
}

const OptionRecruitPeopleV2 = (props: Props) => {
  const { scheduleItem, isDisable, handleSetScheduleItem } = props;
  const minmumQuotaRef = useRef<HTMLInputElement>(null);
  const quotaRef = useRef<HTMLInputElement>(null);

  const handleChangeQuota = (
    key: string,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (isDisable) {
      handleSetScheduleItem({
        [key]: e.target.value.replaceAll(',', ''),
      });

      return;
    }

    if (key === 'minimumQuota') {
      minmumQuotaRef.current?.focus();
    }

    if (key === 'quota') {
      quotaRef.current?.focus();
    }

    handleSetScheduleItem({
      [key]: Number(e.target.value.replaceAll(ONLY_NUMBER_REGEX, '')),
    });
  };

  const renderContents = (): JSX.Element => {
    return (
      <Column align="flex-start" gap="16px">
        <Text color="#414B56" size="18px" weight={600}>
          모집 인원
        </Text>
        <Row gap="12px" style={{ width: '100%' }}>
          <RecruitContainer ref={minmumQuotaRef} $disable={isDisable}>
            <Text color="#1b1c1e" size="14px" weight={400}>
              최소
            </Text>
            <RecruitInput
              type="text"
              value={scheduleItem.minimumQuota}
              onFocus={() => minmumQuotaRef.current?.focus()}
              onBlur={() => minmumQuotaRef.current?.blur()}
              onChange={e => handleChangeQuota('minimumQuota', e)}
              disabled={isDisable}
            />
            <Text color="#1b1c1e" size="14px" weight={400}>
              명
            </Text>
          </RecruitContainer>
          <Text color="#989BA2" size="24px" weight={700}>
            ~
          </Text>
          <RecruitContainer ref={quotaRef} $disable={isDisable}>
            <Text color="#1b1c1e" size="14px" weight={400}>
              최대
            </Text>
            <RecruitInput
              type="text"
              value={scheduleItem.quota}
              onFocus={() => quotaRef.current?.focus()}
              onBlur={() => quotaRef.current?.blur()}
              onChange={e => handleChangeQuota('quota', e)}
              disabled={isDisable}
            />
            <Text color="#1b1c1e" size="14px" weight={400}>
              명
            </Text>
          </RecruitContainer>
        </Row>
      </Column>
    );
  };

  return renderContents();
};

export default OptionRecruitPeopleV2;
